import { Box, Typography } from '@mui/material'
import QuantityModifier from 'components/QuantityModifier';
import React from 'react'
import QuantityModifierOrd from '../../../components/QuantityModifierOrd/QuantityModifierOrd';

export const CardProduct = ({ name, product, state, setState }) => {


  return (
    <Box

  
    display='flex'
    flexDirection='column'
    padding={1.5}
    border={0.3}
    borderRadius={3}
    borderColor='#EEEEEE'
     >

    <Box display='flex' justifyContent='space-between' alignItems='center' >
      <Box sx={{ width:{ lg:315, md:300, xs:220, xl:460 } }} >
         <Typography fontWeight='bold' sx={{ fontSize:{xs:14, md:15} }} >{name} </Typography>
      </Box>
    
      <QuantityModifierOrd
        product={product}
        state={state}
        setState={setState}
        allowChanges={true}
        newOrder={true}
        quantityKey="requestedQuantity"
      />
    </Box>


    {
      product.price === null || product.price === undefined ? null :
        <Typography fontSize={14} mt={-1} > ${`${product.price}/${product.measurementUnit}`} </Typography>
    }


  </Box>
  )
}
